import { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import ManageEvents from "./ManageEvents";
import ManageUsers from "./ManageUsers";
import "../css/Admin.css";
import NotificationPanel from "./NotificationPanel";
import { useAppContext } from "../../Context/AppContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CreateParteners from "./CreateParteners";
import MuslimInvestRequests from "./MuslimInvestRequests";
import MuslimInvestPitchApproval from "./MuslimInvestPitchApproval";
import Investors from "./Investors";
import Reports from "./Reports";
import PaymentErrors from "./PaymentErrors";
import Cancellations from "./Cancellations";

const Admin = () => {
  const [key, setKey] = useState("events");
  const { user } = useAppContext();

  const navigate = useNavigate();

  useEffect(() => {
    if (user?.user?.isAdmin !== 1) {
      navigate("/");
    }
  }, [user, navigate]);

  return (
    <div className="m-0 p-4 pt-5 pt-md-5">
      <div className="card shadow-lg border-0">
        <Tabs
          id="admin-tabs"
          activeKey={key}
          onSelect={(k) => setKey(k || "events")}
          className="mb-3 custom-tabs"
        >
          <Tab
            eventKey="events"
            title={
              <span className={key === "events" ? "text-primary" : "text-dark"}>
                Events
              </span>
            }
          >
            <ManageEvents />
          </Tab>
          <Tab
            eventKey="users"
            title={
              <span className={key === "users" ? "text-primary" : "text-dark"}>
                Users
              </span>
            }
          >
            <ManageUsers />
          </Tab>
          <Tab
            eventKey="notificationPanel"
            title={
              <span
                className={
                  key === "notificationPanel" ? "text-primary" : "text-dark"
                }
              >
                Notification Panel
              </span>
            }
          >
            <NotificationPanel />
          </Tab>
          <Tab
            eventKey="parteners"
            title={
              <span
                className={key === "parteners" ? "text-primary" : "text-dark"}
              >
                Partners
              </span>
            }
          >
            <CreateParteners />
          </Tab>
          <Tab
            eventKey="invest-company"
            title={
              <span
                className={
                  key === "invest-company" ? "text-primary" : "text-dark"
                }
              >
                Invest-Company Approval
              </span>
            }
          >
            <MuslimInvestRequests />
          </Tab>
          {/* <Tab
            eventKey="invest-pitch"
            title={
              <span
                className={
                  key === "invest-pitch" ? "text-primary" : "text-dark"
                }
              >
                Invest-Pitch Approval
              </span>
            }
          >
            <MuslimInvestPitchApproval />
          </Tab> */}
          <Tab
            eventKey="investors"
            title={
              <span
                className={key === "investors" ? "text-primary" : "text-dark"}
              >
                Investors
              </span>
            }
          >
            <Investors />
          </Tab>
          <Tab
            eventKey="reports"
            title={
              <span
                className={key === "reports" ? "text-primary" : "text-dark"}
              >
                Reports
              </span>
            }
          >
            <Reports />
          </Tab>
          <Tab
            eventKey="payment-errors"
            title={
              <span
                className={
                  key === "payment-errors" ? "text-primary" : "text-dark"
                }
              >
                Payment Errors
              </span>
            }
          >
            <PaymentErrors />
          </Tab>
          <Tab
            eventKey="cancellations"
            title={
              <span
                className={
                  key === "cancellations" ? "text-primary" : "text-dark"
                }
              >
                Cancellations
              </span>
            }
          >
            <Cancellations />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default Admin;
